// @flow

import stringify from 'json-stringify-deterministic';
import NodeRSA from 'node-rsa';

export default (key:any, format?:string = 'pkcs1-public-pem') => {
  const publicKey = key instanceof NodeRSA ? key : new NodeRSA(key, format);
  return (signature:string, ...args:Array<any>) => publicKey.verify(stringify(args), signature, 'utf8', 'base64');
};
